module.exports = __webpack_public_path__ + "assets/img/recom-logo.3acf9775.png";